import React, { useState, useEffect } from 'react';
import DataTable from '../components/DataTable';
import { currenciesAPI } from '../lib/api';

const Currencies = () => {
  const [currencies, setCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchCurrencies = async () => {
    setLoading(true);
    try {
      const response = await currenciesAPI.getAll();
      setCurrencies(response.data);
    } catch (error) {
      console.error('Error fetching currencies:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCurrencies();
  }, []);

  const columns = [
    { key: 'code', label: 'Code' },
    { key: 'name', label: 'Currency Name' },
    { key: 'symbol', label: 'Symbol' },
    { key: 'exchange_rate', label: 'Exchange Rate' },
    { 
      key: 'is_default', 
      label: 'Default',
      render: (val) => val ? 'Yes' : 'No'
    },
  ];

  const formFields = [
    { name: 'code', label: 'Currency Code', required: true, placeholder: 'e.g., USD' },
    { name: 'name', label: 'Currency Name', required: true, placeholder: 'e.g., US Dollar' },
    { name: 'symbol', label: 'Symbol', required: true, placeholder: 'e.g., $' },
    { name: 'exchange_rate', label: 'Exchange Rate', type: 'number', defaultValue: 1.0 },
    {
      name: 'is_default',
      label: 'Default Currency',
      type: 'select',
      defaultValue: 'false',
      options: [
        { value: 'false', label: 'No' },
        { value: 'true', label: 'Yes' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    const formattedData = {
      ...data,
      is_default: data.is_default === 'true'
    };
    await currenciesAPI.create(formattedData);
    fetchCurrencies();
  };

  const handleEdit = async (id, data) => {
    const formattedData = {
      ...data,
      is_default: data.is_default === 'true' || data.is_default === true
    };
    await currenciesAPI.update(id, formattedData);
    fetchCurrencies();
  };

  const handleDelete = async (id) => {
    await currenciesAPI.delete(id);
    fetchCurrencies();
  };

  return (
    <DataTable
      title="Currencies"
      description="Manage supported currencies"
      data={currencies}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Currencies;
